module.exports = __webpack_public_path__ + "img/20190516105234btn_7_03.bf45f8c1.png";